import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { MatDialogRef, MatTableDataSource, MatSort, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { RouterModule } from '@angular/router';

import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';
import { forEach } from '@angular/router/src/utils/collection';
import { element } from 'protractor';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-def-inv-cond-list',
  templateUrl: './def-inv-cond-list.component.html',
  styleUrls: ['./def-inv-cond-list.component.css']
})
export class DefInvCondListComponent implements OnInit {

  public menu_item_id = '43';
  public user_auth;
  public add_auth;
  public edit_auth;

  branchList = [];
  private dp = [];
  cond_list = [];

  displayedColumns = ['invoice_type', 'cond_list_id'];
  dataSource = new MatTableDataSource(this.dp);
  @ViewChild(MatSort) sort: MatSort;

  model = { 'table_name': 'def_inv_cond_list', 'def_cond_list_id': '', 'invoice_type_key': '', 
    'cond_list_id': '', 'branch_id': this.applicationConstants.user_branch_info.user_branch_id };

  Success_Msg; Error_Msg;

  constructor(private utils: Utils, private applicationConstants: ApplicationConstants,
    private queryList: QueryList, public dialog: MatDialog, public translate: TranslateService) {
    this.getMessages(translate);
  }

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);


    translate.get('Success_Msg').subscribe((res: string) => {
      this.Success_Msg = res;
    });

    translate.get('Error_Msg').subscribe((res: string) => {
      this.Error_Msg = res;
    });

  }

  ngOnInit() {
    console.log(this.model.branch_id);
    this.add_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.ADD_AUTH);
    this.edit_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.EDIT_AUTH);

    let query = "SELECT DISTINCT `branch`.* FROM `branch`, `branch_auth` WHERE `branch_auth`.`branch_id` =" +
      " `branch`.`branch_id` AND `branch`.`status` = '1' AND `branch_auth`.`status` = '1'" +
      " AND `branch_auth`.`user_id` = '" + this.applicationConstants.user_info.user_id + "'";
    let obj = { cmd: 'getList', query: query };
    
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.branchList = data.data['list'];
      });

    this.getDefConList();
  }

  getDefConList() {
    let query, obj;
    this.dp = [];

    query = "SELECT * FROM `def_inv_cond_list`, `invoice_type` WHERE" + 
      " `def_inv_cond_list`.`status` = '1' AND `def_inv_cond_list`.`branch_id` = '" + 
      this.model.branch_id + "' AND `def_inv_cond_list`.`invoice_type_key` = `invoice_type`.`invoice_type_key`";
    obj = { cmd: 'getList', query: query };

    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        let result = data.data['list'];

        if (result.length > 0) {
          this.user_auth = this.edit_auth;
          this.dp = result;
          this.dataSource = new MatTableDataSource(this.dp);
          this.dataSource.sort = this.sort;
        }
        else {
          this.user_auth = this.add_auth;
          query = "SELECT *, '0' AS `cond_list_id` FROM `invoice_type` WHERE `status`='1'";
          obj = { cmd: 'getList', query: query };

          this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
            .subscribe(data => {
              this.applicationConstants.appComp.hideBusyCursor();
              this.dp = data.data['list'];
              this.dataSource = new MatTableDataSource(this.dp);
              this.dataSource.sort = this.sort;
            });
        }
      });

    query = this.queryList.all_invCondList + " AND (`branch_id` = '0' OR `branch_id` = '" + 
      this.model.branch_id + "')";
    obj = { cmd: 'getList', query: query };
    
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();

        this.cond_list = data.data['list'];
        this.cond_list.unshift({ 'cond_list_id': '0', 'list_name': 'اختر', 'list_name_en': 'Select' });
      });
  }

  save() {
    let values = [];
    // let where = []; where.push({ 'def_cond_list_id': inv.def_cond_list_id }); , where: where

    this.dp.forEach(inv => {
      values.push({ 'table_name': this.model['table_name'], 
        'def_cond_list_id': (inv.def_cond_list_id == undefined ? '0': inv.def_cond_list_id), 
        'invoice_type_key': inv.invoice_type_key, 
        'cond_list_id': inv.cond_list_id, 
        'flag': (inv.def_cond_list_id == undefined ? 'new' : 'update'), 'key': 'def_cond_list_id',
        'branch_id': this.model.branch_id });
    });

    let obj = { cmd: 'updateAdv', values: values }; 
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        
        if (data.status['type'] == 'success') 
          alert(this.Success_Msg);
        else if (data.status['type'] != 'success') 
          alert(this.Error_Msg);
        
      });
  }

}